import axios from "axios";
import TableRekap from "./table/tableRekap";
import React, { useEffect, useState } from "react";
import { DataAPi } from "./variable/dataVariable";

function Rekapitulasi() {
    const [data, setData] = useState([]);
    
    useEffect(() => {
        const getAset = async() => {
            await axios.get(DataAPi.urlGetAll)
            .then(res => {
                setData(res.data)
            })
            .catch(err => console.log(err));
        }
        getAset();
    },[]);

    return(
        <>
        <div className="container justify-content-center bg-light">
            <br />
            <TableRekap dataSet={data} />
            <br />
        </div>
        </>
    )
}

export default Rekapitulasi;